import { useQuery } from '@tanstack/react-query';
import { useAppAuth } from './useAppAuth';
import { createApiClient, trafficNewsService } from '../services/api';
import type { TrafficIncident } from '../types';

// Traffic incidents filtered against every point of a job's route polyline (not just one
// center point) — used on the job detail page's live-tracking widget. Mirrors useTrafficNews'
// query shape but hits the route-corridor endpoint (TrafficNewsController.GetIncidentsAlongRoute).
export function useRouteTrafficNews(
  routePoints: { lat: number; lng: number }[], corridorMiles = 5, enabled = true
) {
  const { getToken } = useAppAuth();
  const key = routePoints.length > 0
    ? `${routePoints[0].lat.toFixed(3)},${routePoints[0].lng.toFixed(3)}|` +
      `${routePoints[routePoints.length - 1].lat.toFixed(3)},${routePoints[routePoints.length - 1].lng.toFixed(3)}|` +
      routePoints.length
    : '';

  return useQuery<TrafficIncident[]>({
    queryKey: ['traffic-news-route', key, corridorMiles],
    queryFn: async () => {
      const client = createApiClient(getToken);
      return trafficNewsService(client).getIncidentsAlongRoute(routePoints, corridorMiles);
    },
    enabled: enabled && routePoints.length > 0,
    staleTime: 5 * 60_000,
  });
}
